import { t } from 'i18next';

export const locationAdministrationTabs = {
  openingHoursGroup: {
    key: 'opening-hours-group',
    label: t('settings.locationAdministration.openingHoursGroup.title'),
  },
  assetTypes: {
    key: 'asset-types',
    label: t('settings.locationAdministration.assetTypes.title'),
  },
  manageJobTypes: {
    key: 'manage-job-types',
    label: t('settings.locationAdministration.manageJobTypes.title'),
  },
  priceBeat: {
    key: 'price-beat',
    label: t('settings.locationAdministration.priceBeat.title'),
  },
  locationCategories: {
    key: 'location-categories',
    label: t('settings.locationAdministration.locationCategories'),
  },
};
